var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeavesBy2 = function SvgLeavesBy2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00674F",
    d: "M12.869 0C6.056 0 .535 5.522.535 12.333v6.64h5.692c6.811 0 12.333-5.521 12.333-12.332V0zM28.253 0c6.81 0 12.332 5.522 12.332 12.333v6.64h-5.692c-6.81 0-12.332-5.521-12.332-12.332V0zM56.918 18.973c-6.81 0-12.332-5.521-12.332-12.332V0h5.692c6.81 0 12.332 5.52 12.332 12.332v6.64zM72.302 18.973c6.811 0 12.333-5.521 12.333-12.332V0h-5.692C72.132 0 66.61 5.52 66.61 12.332v6.64z"
  })));
};
export default SvgLeavesBy2;